import React, { useState, useEffect } from "react";
import {
  Tabs,
  message,
  Divider,
  Form,
  Alert,
  Radio,
  Input,
  Button,
  Checkbox,
  Modal,
  Layout,
  DatePicker,
  Select,
  Menu,
  Dropdown,
  InputNumber,
  Row,
  Col,
  Space,
} from "antd";
import LoginInput from "@/components/loginInput";
import logo from "@/assets/logo.png";
import pol from "@/image/111.png";
import userImg from "@/assets/user.png";
import teamImg from "@/assets/team.png";
import RZ from "@/assets/rz.png";
import moment from "moment";
import { ageFun } from "@/utils/utils";
import ErCode from "@/components/erCode";
import { genTokenIdApi } from "@/services/auth";
import PubSub from "pubsub-js";
import {
  login1,
  isRepeatAccount,
  sendVerifyCode1,
  getCountriesApi,
  register1,
  loginAccountChoice,
  register,
  verifyApi,
} from "@services/auth";
import { messageModal } from "@utils/message-modal";
import CustomerFeedback from "@/components/customerFeedback";
import { getUserInfoToLocal, getUserInfoToLocalEmailPhone } from "@/utils/auth";
import {
  UserAddOutlined,
  HeartOutlined,
  RightOutlined,
  ArrowLeftOutlined,
  LogoutOutlined,
  UserOutlined,
  DownOutlined,
  GlobalOutlined,
  BellFilled,
  ExclamationCircleFilled,
  DeleteOutlined,
} from "@ant-design/icons";
import "./login.less";
//react文件预览支持docx，xlsx
import FileViewer from "react-file-viewer";
import zh_CN_Userfile from "@/assets/userPolicy.docx";
import zh_CN_Teamfile from "@/assets/supplierPolicy.docx";
import en_US_Userfile from "@/assets/userPolicyEn.docx";
import en_US_Teamfile from "@/assets/supplierPolicyEn.docx";
import en_US from "@/locales/en_US/index.json";
import zh_CN from "@/locales/zh_CN/index.json";
import { createFromIconfontCN } from "@ant-design/icons";
import { setDetailType, setBgColor } from "@utils/auth";
import { getQueryVariable, bgColor, IsPc } from "@/utils/utils";
import { checkInvitationCodeApi, joinTeamApi } from "@/services/personalCenter";
//语言切换
import intl from "react-intl-universal";
import { TeamBindModal } from "./admin/components/TeamModal";
const IconFont = createFromIconfontCN({
  scriptUrl: [process.env.REACT_APP_ICON],
});

// const code = getQueryVariable("code");
// const state = getQueryVariable("state");
// if (window.location.href.includes("/?code=")) {
//   window.location.href = `https://dots-test.dataoceanai.com/login?code=${code}&state=${state}`;
// }

const locales = {
  en_US,
  zh_CN,
};
const { TabPane } = Tabs;
const { Option } = Select;
const { Header, Content, Footer } = Layout;

export default function Login(props) {
  const filePath =
    localStorage.getItem("language_type") === "en_US"
      ? en_US_Userfile
      : zh_CN_Userfile;
  const teamFilePath =
    localStorage.getItem("language_type") === "en_US"
      ? en_US_Teamfile
      : zh_CN_Teamfile;
  const [showFlag, setShowFlag] = useState(true);
  const [regFormTeam] = Form.useForm(); // 登录/注册 团队
  const [regFormTerminal] = Form.useForm(); // 登录/注册 用户
  const [authForm] = Form.useForm(); // 账号认证
  const [status, setStatus] = useState(); //data里返回的是2的时候。去加入团队，返回其他不加
  const [currentKey, setCurrentKey] = useState("1");
  const [isLogin, setIsLogin] = useState(1); // 1 登录界面  2 注册界面  3 选择用户界面  4 注册用户账号 5 注册个人/企业团队账号
  const [selectPersonalData, setSelectPersonalData] = useState([]); // 选择用户数据
  const [supplierType, setSupplierType] = useState(3); // 团队类型
  const [isOverseas, setIsOverseas] = useState(1); // 海外团队
  const [phone, setPhone] = useState(""); // 手机号
  const [email, setEmail] = useState(""); // 邮箱
  const [codeFor, setCodeFor] = useState(false); // 验证码是否禁用
  const [agreeFlag, setAgreeFlag] = useState(false); // 服务协议选择
  let [countDown, setCountDown] = useState(60); // 倒计时60s
  const [code, setCode] = useState(); // 验证码文本
  const [interTime, setInterTime] = useState(null); // 定时器
  const [agreeMent, setAgreeMent] = useState(false); // 服务协议弹窗开关
  let [agreeTime, setAgreeTime] = useState(5); // 服务协议倒计时
  const [agreeInter, setAgreeInter] = useState(null); // 服务协议定时器
  const [methodsStatus, setMethodsStatus] = useState(1); // 注册方式
  const [countriesData, setCountriesData] = useState(1); // 国家数据
  const [regMess, setRegMess] = useState(false); // 注册信息核实弹窗
  const [supplierName, setSupplierName] = useState(""); // 团队名称
  const [isDisAbled, setIsDisAbled] = useState(""); // 注册方式是否禁用
  const [subModalFlag, setSubModalFlag] = useState(false); // 认证弹窗
  const [subModalFlag1, setSubModalFlag1] = useState(false); // 账号认证1
  const [subModalFlag2, setSubModalFlag2] = useState(false); // 账号认证2
  const [isTeamBindModal, setIsTeamBindModal] = useState(false); // 绑定团队弹窗是否展示
  const [isTeamStartModal, setIsTeamStartModal] = useState(false); // 启用团队弹窗是否展示
  const [bindModalType, setBindModalType] = useState("ad"); // 绑定团队弹窗类型ad、choose、dots、dotsLike, dotsSearch,dotsNoResult
  const [teamData, setTeamData] = useState(); // 团队查询数据
  const [teamBindDataList, setTeamBindDataList] = useState([]); // 绑定团队选择的数据
  const [loginData, setLoginData] = useState(); // 登陆账号信息

  const getCookieValue = (cookieName) => {
    if (document.cookie) {
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.indexOf(cookieName + "=") === 0) {
          return cookie.substring(cookieName.length + 1);
        }
      }
      return undefined;
    }
    return undefined;
  };

  useEffect(() => {
    const browserLang = navigator.language || navigator.userLanguage;
    const cookieLang = getCookieValue("languageType");
    if (cookieLang) {
      localStorage.setItem("language_type", cookieLang);
    } else {
      const defaultLang = browserLang.indexOf("zh") !== -1 ? "zh_CN" : "en_US";
      localStorage.setItem("language_type", defaultLang);
      const date = new Date("Fri, 31 Dec 9999 23:59:59 GMT");
      document.cookie =
        "languageType=" +
        defaultLang +
        "; expires=" +
        date.toUTCString() +
        ";path=/;domain=.dataoceanai.com";
    }
    if (
      window.location.href.includes("speechocean") &&
      !window.location.href.includes("workbee.speechocean")
    ) {
      const url = window.location.href.replace("speechocean", "dataoceanai");
      window.open(url, "_self");
    }
    if (window.location.href.includes("http://dhb.pnlkj.com")) {
      const url = window.location.href.replace(
        "http://dhb.pnlkj.com",
        "https://dhb.pnlkj.com",
      );
      window.open(url, "_self");
    }
    intl
      .init({
        currentLocale: localStorage.getItem("language_type") || "zh_CN",
        locales,
      })
      .then(() => {});

    setCode(
      intl.get("Get_verification_code_1481e151-e3f9-21c8-bec6-96251ef32e68"),
    ); //验证码文本

    // if (!IsPc().isPc) {
    //   if (getQueryVariable("invitationCode")) {
    //     window.location.href = `${
    //       process.env.REACT_APP_H5_URL
    //     }/#/index?invitationCode=${getQueryVariable("invitationCode")}`;
    //   } else {
    //     window.location.href = `${process.env.REACT_APP_H5_URL}/#/index`;
    //   }
    // }

    localStorage.setItem("login-reg-dots-userType", "1");
    // 国家
    countriesFun().then((countriesData) => {
      setCountriesData(countriesData);
    });
    if (getQueryVariable("invitationCode")) {
      checkInvitationCodeApi(getQueryVariable("invitationCode")).then((res) => {
        if (res.code === 0) {
          setStatus(res?.data);
          let formData = {
            invitationCode: getQueryVariable("invitationCode"),
          };
          regFormTerminal.setFieldsValue(formData);
        } else {
          Modal.error({
            title: intl.get("Tips_f41babef-2238-24b3-8e39-bdb7bcb07d16"),
            content: res.message,
            okText: intl.get("Confirm_fc189f71-934f-2caa-bd8f-29b9460afa19"),
            centered: true,
            onOk() {
              window.location.href = `/login`;
            },
          });
        }
      });
    }

    regFormTeam.resetFields();
    regFormTerminal.resetFields();
  }, []);

  // 用户注册选择国家
  const changeCountry = (e) => {
    if (e == 44) {
      // 中国
      regFormTerminal.setFieldsValue({ registMethod: 1 });
      setMethodsStatus(1);
    } else {
      // 外国
      regFormTerminal.setFieldsValue({ registMethod: 2 });
      setMethodsStatus(2);
    }
    setCodeFor(false);
    setCountDown(60);
    setCode(
      intl.get("Get_verification_code_1481e151-e3f9-21c8-bec6-96251ef32e68"),
    );
    clearInterval(interTime);
    setPhone("");
    setEmail("");
    regFormTerminal.setFieldsValue({
      mobile: "",
      email: "",
      phoneEmail: "",
    });
    setIsDisAbled(true);
  };

  const onChangeModal = async (name, e, i) => {
    console.log(e.target.checked);
    setAgreeFlag(e.target.checked);
  };

  function countriesFun() {
    return new Promise((resolve, reject) => {
      getCountriesApi("countries").then((res) => {
        if (res.code === 0) {
          resolve(res.data);
        } else {
          message.error(res.message);
        }
      });
    });
  }

  const setKeyFun = (key) => {
    setCurrentKey(key);
    setAgreeFlag(false);
    localStorage.setItem("login-reg-dots-userType", key);
  };

  const loginSuccess = (res) => {
    localStorage.setItem("userInfo-dots", JSON.stringify(res.data));
    localStorage.setItem("userInfo-dots-email-phone", JSON.stringify(res.data));
    localStorage.setItem("dots-userType", res.data.userType);
    message.success(res.message);
    if (res.data.choice) {
      // 选择用户
      setSelectPersonalData(res.data.userInfo);
      setIsLogin(3);
    } else {
      // 直接登录
      setBgColor(bgColor());

      if (currentKey == 2) {
        // 供应商登录
        const baseInfo = {
          isOverseas: res.data.isOverseas,
          supplierStatus: res.data.supplierStatus,
        };
        localStorage.setItem("supplierbase", JSON.stringify(baseInfo));
      }
      //data里返回的是2的时候。去加入团队，返回其他不加
      if (getQueryVariable("invitationCode") && status == 2) {
        joinTeamApi(getQueryVariable("invitationCode")).then(async (res) => {
          if (res.code === 0) {
            goRedirected();
          } else {
            message.error(res.message);
          }
        });
      } else {
        goRedirected();
      }
    }
  };

  // 登录
  const loginFun = (values) => {
    login1({ ...values, userType: currentKey }).then((res) => {
      if (res.code === 0) {
        loginSuccess(res);
      } else if (res.code === 2) {
        localStorage.setItem("userInfo-dots", JSON.stringify(res.data));
        localStorage.setItem(
          "userInfo-dots-email-phone",
          JSON.stringify(res.data),
        );
        setSubModalFlag(true);
      } else if (res.code === 5006) {
        //ad对接团队
        setLoginData(values);
        if (res.data.adTeamVos.length === 0) {
          //noResult 没有查询到结果
          setBindModalType("dotsNoResult");
        } else if (res.data.adTeamVos[0].sourceCode === "AD") {
          //ad
          setBindModalType("ad");
        } else if (res.data.adTeamVos[0].sourceCode === "DOTS") {
          if (
            res.data.adTeamVos.filter((item) => item.searchType === 3)
              .length === 0
          ) {
            //dots
            setBindModalType("dots");
          } else {
            //dotsLike
            setBindModalType("dotsLike");
          }
        }
        setTeamData(res.data);
        setIsTeamBindModal(true);
        return;
      } else {
        message.error(res.message);
        return;
      }
    });
  };

  // 登录跳转
  const goHome = (data) => {
    loginAccountChoice(data.id).then((res) => {
      if (res.code === 0) {
        setBgColor(bgColor());
        localStorage.setItem("userInfo-dots", JSON.stringify(res.data));
        localStorage.setItem(
          "userInfo-dots-email-phone",
          JSON.stringify(res.data),
        );
        localStorage.setItem("dots-userType", res.data.userType);
        if (getQueryVariable("invitationCode")) {
          joinTeamApi(getQueryVariable("invitationCode")).then((res) => {
            if (res.code === 0) {
              goRedirected();
            } else {
              message.error(res.message);
            }
          });
        } else {
          goRedirected();
        }
      } else {
        message.error(res.message);
      }
    });
  };

  const goRedirected = async () => {
    const redirect = window.location.href;
    if (redirect.includes("redirect")) {
      const url = redirect.split("redirect=")[1];
      const token = await genTokenId();
      if (url.includes("#")) {
        const lastUrl = url.split("#")[0];
        if (lastUrl.includes("?")) {
          window.location.href = lastUrl + "&dots-uuid=" + token;
        } else {
          window.location.href = lastUrl + "?dots-uuid=" + token;
        }
      } else {
        if (url.includes("?")) {
          window.location.href = url + "&dots-uuid=" + token;
        } else {
          window.location.href = url + "?dots-uuid=" + token;
        }
      }
    } else {
      props.history.push("/admin/home");
    }
  };

  // 获取token
  const genTokenId = () => {
    return new Promise((resolve, reject) => {
      genTokenIdApi().then((res) => {
        if (res.code === 0) {
          resolve(res.data);
        } else {
          message.error(res.message);
          return;
        }
      });
    });
  };

  // 切换团队
  const supplierChange = (e) => {
    setSupplierType(e.target.value);
  };

  // 切换是否海外
  const seaSupplierChange = (e) => {
    setIsOverseas(e.target.value);
  };

  const nextStep = (isTrue) => {
    if (isTrue) {
      closeWindow();
    }
  };

  // 关闭弹窗
  const closeWindow = () => {
    regFormTerminal.resetFields();
    regFormTeam.resetFields();
    PubSub.unsubscribe("erCodeState");
  };

  //可选择当前日期之前
  const disabledDate = (current) => {
    return current && current > moment().subtract(1, "days").endOf("day");
  };

  // 服务协议
  const openAgreeMent = (e) => {
    e.preventDefault();
    setAgreeMent(true);
    const int = setInterval(() => {
      setAgreeTime(--agreeTime);
      if (agreeTime <= 0) {
        setAgreeTime("");
        clearInterval(int);
      }
    }, 1000);
    setAgreeInter(int);
  };

  // 关闭服务协议
  const closeAgreeMent = () => {
    setAgreeMent(false);
    setAgreeTime(5);
    clearInterval(agreeInter);
  };

  // 关闭服务协议
  const closeAgreeMentSure = () => {
    setAgreeMent(false);
    setAgreeTime(5);
    clearInterval(agreeInter);
    setAgreeFlag(true);
  };

  // 注册
  const onFinish = (values) => {
    if (!agreeFlag) {
      messageModal(
        intl.get("Please_3b96436d-7539-2d79-97a8-d07b479cd5a2_Please"),
      );
      return;
    }

    if (!values.verifyCode) {
      messageModal(
        intl.get(
          "Please_enter_the_verification_code_fe7d2bae-6b48-23f9-aee7-9dde14986a39",
        ),
      );
      return;
    }

    // 用户注册
    if (isLogin == 4) {
      values.registMethod = methodsStatus;
      values.birthday = moment(values.birthday).format("YYYY-MM-DD");
      const age = ageFun(values.birthday);
      if (age < 16) {
        message.warning(intl.get("d458a894-deed-230f-acc1-90cf336b8ee1"));
        return;
      } else if (age > 100) {
        message.warning(intl.get("d458a894-deed-230f-acc1-90cf336b8ee2"));
        return;
      }

      if (values.registMethod == 1) {
        values.mobile = values.phoneEmail;
      } else {
        values.email = values.phoneEmail;
      }

      register1(values).then((res) => {
        if (res.code === 0) {
          message.success(intl.get("198d09ea-d262-2ebe-a499-87ebdaf95903"));
          setTimeout(() => {
            loginFun({
              username: values.phoneEmail,
              password: values.password,
            });
          }, 1000);
        } else {
          message.error(res.message);
        }
      });
    } else if (isLogin == 5) {
      // 个人/团队
      setSupplierName(values.supplierName);
      setRegMess(true);
    }
  };

  // 确认注册
  const regMessSure = () => {
    const registerData = regFormTeam.getFieldValue();
    if (registerData.isOverseas == 1) {
      registerData.phone = registerData.phoneEmail;
    } else {
      registerData.email = registerData.phoneEmail;
    }

    register(registerData).then((res) => {
      if (res.code === 0) {
        message.success(intl.get("198d09ea-d262-2ebe-a499-87ebdaf95903"));
        setTimeout(() => {
          //  登录
          loginFun({
            username: registerData.phoneEmail,
            password: registerData.password,
          });
        }, 1000);
      } else {
        messageModal(res.message);
        return;
      }
    });
  };

  // 账号认证确认
  const onAuthForm = (values) => {
    if (!values.verifyCode) {
      message.error(
        intl.get(
          "The_verification_code_cannot_be_empty_0e8fc4d3-59b1-2b44-bb33-d70f9de7e5bb",
        ),
      );
      return;
    }

    if (methodsStatus == 1) {
      values.mobile = values.phoneEmail;
    } else {
      values.email = values.phoneEmail;
    }

    verifyApi({
      ...values,
      verifyType: methodsStatus,
      id: getUserInfoToLocal().id,
      loginUserType:
        localStorage.getItem("login-reg-dots-userType") ||
        sessionStorage.getItem("login-reg-dots-userType"),
    }).then((res) => {
      if (res.code === 0) {
        message.success(res.message);
        setTimeout(() => {
          setSubModalFlag2(false);
          props.history.push("/login");
        }, 1000);
      } else {
        message.error(res.message);
        return;
      }
    });
  };

  const yrz = {
    color: "#00B42A",
    background: "#E8FFEA",
    display: "inline-block",
    padding: "0 5px",
  };

  const wrz = {
    color: "#1D2129",
    background: "#F2F3F5",
    display: "inline-block",
    padding: "0 5px",
  };

  return (
    <div className="site-layout login-div">
      <div className="logosWrapper">
        <img src={logo} className="logos" />
        <div
          style={{
            justifyContent: "space-between",
            display: "inline-flex",
            padding: "2px 8px",
            backgroundColor: "#fff7ce",
            marginLeft: "15px",
            width: "70%",
            fontSize: "13px",
            lineHeight: "inherit",
            verticalAlign: "top",
          }}
        >
          <div>
            &nbsp;
            <ExclamationCircleFilled
              style={{
                padding: "4px",
                color: "red",
                borderRadius: "50%",
              }}
            />
            &nbsp;{intl.get("dfa73eca-fb9c-2f10-89f3-8d2990c89eca")}
          </div>
        </div>
        {/* {showFlag ? (
          <div
            style={{
              justifyContent: "space-between",
              display: "inline-flex",
              padding: "2px 8px",
              backgroundColor: "#fff7ce",
              marginLeft: "15px",
              width: "70%",
              fontSize: "13px",
              lineHeight: "inherit",
              verticalAlign: "top",
            }}
          >
            <div>
              &nbsp;
              <BellFilled
                style={{
                  padding: "4px",
                  backgroundColor: "#fff",
                  color: "red",
                  borderRadius: "50%",
                }}
              />
              &nbsp;{intl.get("f656fab4-b2da-279f-a941-52940629214a")}
            </div>
            <div
              className="pointer"
              style={{
                width: "90px",
                textAlign: "right",
              }}
              onClick={() => {
                setShowFlag(false);
              }}
            >
              X&nbsp;{intl.get("close_6d09043f-7b30-23f7-9ccc-31dc693bc26d")}
            </div>
          </div>
        ) : null} */}
      </div>
      {isLogin == 1 || isLogin == 2 || isLogin == 3 ? (
        <div className="login">
          <div className="login-box">
            {isLogin != 3 ? (
              <h1>
                {intl.get("Powerful_60431d9d-16a9-2ada-aab5-d2d3e7d2817a")}
              </h1>
            ) : (
              <h3>{intl.get("35cb127a-9591-2338-934b-aa53b2bcb184")}</h3>
            )}
            {isLogin == 1 ? (
              <div className="login-tab">
                <Tabs
                  defaultActiveKey="1"
                  onChange={setKeyFun}
                  centered
                  tabBarGutter={80}
                >
                  <TabPane
                    tab={intl.get("2e11a3bf-9fe7-2012-9b35-7d574ea3fd74")}
                    key="1"
                  >
                    <LoginInput
                      currentKey="1"
                      loginFun={loginFun}
                      registerFun={() => {
                        setIsLogin(2);
                      }}
                      openAgreeMentFather={openAgreeMent}
                      agreeFlag={agreeFlag}
                      onChangeModal={onChangeModal}
                    />
                  </TabPane>
                  <TabPane
                    tab={intl.get(
                      "supplier_1d39cd71-b93b-2aa9-8ba2-5da1b79aaf3f",
                    )}
                    key="2"
                  >
                    <LoginInput
                      currentKey="2"
                      loginFun={loginFun}
                      registerFun={() => {
                        setIsLogin(2);
                      }}
                      openAgreeMentFather={openAgreeMent}
                      agreeFlag={agreeFlag}
                      onChangeModal={onChangeModal}
                    />
                  </TabPane>
                  {/* <TabPane tab="企业" key="3">
                        <LoginInput currentKey="3" loginFun={loginFun} />
                      </TabPane> */}
                  <TabPane
                    tab={intl.get("dac9e7f3-bc3d-2eff-aeae-9a22f019f0eb")}
                    key="4"
                  >
                    <LoginInput currentKey="4" loginFun={loginFun} />
                  </TabPane>
                </Tabs>
              </div>
            ) : isLogin == 2 ? (
              <div className="register-tab">
                <p className="register-tab-title">
                  {intl.get("b70b8519-410b-2298-bf5b-68834ddfae36")}:
                </p>
                <div className="register-tab-top">
                  <div
                    onClick={() => {
                      setCurrentKey("1");
                      localStorage.setItem("login-reg-dots-userType", "1");
                      setIsLogin(4);
                    }}
                  >
                    <img className="regImg" src={userImg} />
                    <p className="register-tab-top-name">
                      {intl.get("2e11a3bf-9fe7-2012-9b35-7d574ea3fd74")}
                    </p>
                    <p className="register-tab-top-des">
                      {intl.get("e6e1f07b-b4a4-24dd-ab62-6bf6adaf1656")}
                    </p>
                  </div>
                  <div
                    onClick={() => {
                      setCurrentKey("2");
                      localStorage.setItem("login-reg-dots-userType", "2");
                      setIsLogin(5);
                    }}
                  >
                    <img className="regImg" src={teamImg} />
                    <p className="register-tab-top-name">
                      {intl.get("aac1d3d6-7253-2459-a164-972b517d8af5")}
                    </p>
                    <p className="register-tab-top-des">
                      {intl.get("09cbb09c-ae6b-2767-bd5c-6ca1582d52bd")}
                    </p>
                  </div>
                </div>
                <Divider />
                <div className="register-tab-bottom">
                  <span>
                    {intl.get(
                      "Already_account_64840ff2-f4a2-26ad-ac9b-ae0bff3bc483",
                    )}
                    <span
                      className="register-tab-bottom-register"
                      onClick={() => {
                        setCurrentKey(1);
                        setIsLogin(1);
                      }}
                    >
                      {intl.get("Login_7b3caf4e-b296-2437-9bb8-b25c327406d8")}
                    </span>
                  </span>
                </div>
              </div>
            ) : isLogin == 3 ? (
              <div className="selectPersonal">
                {selectPersonalData?.map((item) => {
                  return (
                    <div
                      className="selectPersonal-box"
                      key={item.id}
                      onClick={() => {
                        goHome(item);
                      }}
                    >
                      <span>{item.name?.slice(0, 1)}</span>
                      <span>{item.name ? item.name : "null"}</span>
                      <span className="bir">({item.birthday})</span>
                      <span className="chang">切换该账号</span>
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        ""
      )}

      {isLogin == 4 || isLogin == 5 ? (
        <div className="other-box">
          {isLogin != 3 ? (
            <h1>{intl.get("Powerful_60431d9d-16a9-2ada-aab5-d2d3e7d2817a")}</h1>
          ) : (
            <h3>{intl.get("35cb127a-9591-2338-934b-aa53b2bcb184")}</h3>
          )}
          {isLogin == 4 ? (
            <div className="register-main">
              <h2>
                <ArrowLeftOutlined
                  onClick={() => {
                    setIsLogin(2);
                    setCodeFor(false);
                    setCountDown(60);
                    setCode(
                      intl.get(
                        "Get_verification_code_1481e151-e3f9-21c8-bec6-96251ef32e68",
                      ),
                    );
                    clearInterval(interTime);
                  }}
                />
                &nbsp; {intl.get("aff29d9c-5f57-251a-ac96-d19b469fc251")}
              </h2>
              <Form
                form={regFormTerminal}
                name="basic1"
                onFinish={onFinish}
                autoComplete="off"
                className="login-main"
                initialValues={{ registMethod: 1 }}
                style={{ margin: "auto" }}
                labelWrap
                labelAlign="left"
              >
                <Form.Item>
                  <Alert
                    message={intl.get("81923149-9a4a-247d-a61a-32c0bc16c73c")}
                    banner
                  />
                </Form.Item>

                <Form.Item name="invitationCode" className="m0">
                  <Input type="hidden" size="large" />
                </Form.Item>

                <Form.Item
                  className="special labelWidth"
                  label={intl.get("2e8128b6-4f43-2f03-bd8d-d0261efa2d92")}
                  name="countryId"
                  rules={[
                    {
                      required: true,
                      message: intl.get("8cc899ea-c72e-2500-a8e2-1b77226b5d40"),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder={intl.get(
                      "ff7e4149-4186-2f06-b0b5-f659586a761a",
                    )}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    style={{ width: "283px" }}
                    size="large"
                    allowClear
                    onChange={changeCountry}
                  >
                    {countriesData?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {localStorage.getItem("language_type") === "en_US"
                          ? item.name
                          : item.cname}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="name"
                  label={intl.get("91add215-c0d3-2702-941a-004c11b293c4")}
                  className="special"
                  rules={[
                    {
                      required: true,
                      message: intl.get("b946eed7-156d-20d1-a24f-fb4cb8f4d328"),
                    },
                    {
                      pattern:
                        /^(?:[\u4e00-\u9fa5\u3400-\u4DBF]{2,20}(?:·[\u4e00-\u9fa5\u3400-\u4DBF]{1,19})?|[A-Za-z\s'-.]{1,50}(?:\s[A-Za-z\s'-.]{1,50})?)$/,
                      message: intl.get("enter_valid_name"),
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder={intl.get(
                      "b946eed7-156d-20d1-a24f-fb4cb8f4d328",
                    )}
                  />
                </Form.Item>

                <Form.Item
                  label={intl.get(
                    "Gender_e7081f38-1d17-2bf4-a557-61f69b3b3115",
                  )}
                  className="special labelWidth"
                  name="gender"
                  rules={[
                    {
                      required: true,
                      message: intl.get("6b462a6f-b548-27d4-8d9e-24935aac4fa5"),
                    },
                  ]}
                >
                  <Radio.Group>
                    <Radio value={1}>
                      {intl.get("Male_598a82aa-7401-2dfc-8b48-7c36729c73e1")}
                    </Radio>
                    <Radio value={2}>
                      {intl.get("Female_4b0de2c4-3507-2883-a018-355a961170c3")}
                    </Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item
                  label={intl.get("1b0f4de2-cde4-2508-a085-b032fb524a49")}
                  className="special labelWidth"
                  name="birthday"
                  rules={[
                    {
                      required: true,
                      message: intl.get("87bdc2f8-aae5-2421-a379-fe18dad2dde7"),
                    },
                  ]}
                >
                  <DatePicker
                    size="large"
                    style={{ width: "100%" }}
                    placeholder={intl.get(
                      "87bdc2f8-aae5-2421-a379-fe18dad2dde7",
                    )}
                    disabledDate={disabledDate}
                    format="YYYY-MM-DD"
                  />
                </Form.Item>

                {/* <Form.Item
                  label={intl.get("56fcd126-671c-2220-90f4-30a67b5b5f01")}
                  className="special labelWidth"
                  name="registMethod"
                  rules={[
                    {
                      required: true,
                      message: intl.get("1b6ca4b1-1d98-262c-8176-11ef5582e95f"),
                    },
                  ]}
                >
                  <Radio.Group
                    onChange={(e) => {
                      setCodeFor(false);
                      setCountDown(60);
                      setCode(
                        intl.get(
                          "Get_verification_code_1481e151-e3f9-21c8-bec6-96251ef32e68"
                        )
                      );
                      clearInterval(interTime);
                      setPhone("");
                      setEmail("");
                      regFormTerminal.setFieldsValue({
                        mobile: "",
                        email: "",
                      });

                      setMethodsStatus(e.target.value);
                    }}
                    disabled={isDisAbled}
                  >
                    <Radio value={1}>
                      {intl.get(
                        "Mobile_phone_number_1369de70-73d4-254a-a628-3eaf126e7217"
                      )}
                    </Radio>
                    <Radio value={2}>
                      {intl.get("Email_c1358cc1-828e-291f-a81e-46733c5fe410")}
                    </Radio>
                  </Radio.Group>
                </Form.Item> */}

                <ErCode
                  type={methodsStatus}
                  isCheck={true}
                  nextStep={nextStep}
                  isReg={true}
                  forms={regFormTerminal}
                />

                <Form.Item
                  label={intl.get(
                    "Password_53aeeeeb-f4b2-2ec7-8378-0824b54674f2",
                  )}
                  name="password"
                  className="special"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: intl.get(
                        "Password_e20ad08a-94e5-2741-8abc-622d44e1ef0d_Password",
                      ),
                    },
                    {
                      pattern: new RegExp(
                        /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
                      ),
                      message: intl.get(
                        "Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb",
                      ),
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder={intl.get(
                      "Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb",
                    )}
                  />
                </Form.Item>

                <Form.Item
                  label={intl.get(
                    "Confirm_password_c11a821c-0a36-263d-a77a-30097899f35e",
                  )}
                  name="passwordConfirm"
                  className="special"
                  dependencies={["password"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: intl.get(
                        "Password_e20ad08a-94e5-2741-8abc-622d44e1ef0d_Password",
                      ),
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            intl.get(
                              "The_passwords_entered_twice_do_not_match_8613bcda-26a3-2814-95fc-027239abaee3",
                            ),
                          ),
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder={intl.get(
                      "Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb",
                    )}
                  />
                </Form.Item>

                <Form.Item className="login-btn">
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    style={{ width: "100%" }}
                  >
                    {intl.get(
                      "Create_one_8d829590-c95d-2efd-b0b0-89efd94ce07d",
                    )}
                  </Button>
                </Form.Item>

                <Form.Item className="login-read">
                  <Checkbox
                    checked={agreeFlag}
                    onChange={(e) => {
                      setAgreeFlag(e.target.checked);
                    }}
                  >
                    {intl.get(
                      "Read_agreeed_1f509815-fe90-291d-a8b5-a4ce092c8739",
                    )}
                    <span className="login-read-serve" onClick={openAgreeMent}>
                      {intl.get(
                        "Speechocean_Service_agreement_877db9c4-062c-2fe7-8f57-3be9dd4a4092",
                      )}
                    </span>
                  </Checkbox>
                </Form.Item>

                <Divider />
                <Form.Item className="login-reg">
                  <span>
                    {intl.get(
                      "Already_account_64840ff2-f4a2-26ad-ac9b-ae0bff3bc483",
                    )}
                    <span
                      className="login-reg-register"
                      onClick={() => {
                        setIsLogin(1);
                        setCurrentKey(1);
                        setAgreeFlag(false);
                      }}
                    >
                      {intl.get("Login_7b3caf4e-b296-2437-9bb8-b25c327406d8")}
                    </span>
                  </span>
                </Form.Item>
              </Form>
            </div>
          ) : isLogin == 5 ? (
            <div className="register-main">
              <h2>
                <ArrowLeftOutlined
                  onClick={() => {
                    setIsLogin(2);
                    setCodeFor(false);
                    setCountDown(60);
                    setCode(
                      intl.get(
                        "Get_verification_code_1481e151-e3f9-21c8-bec6-96251ef32e68",
                      ),
                    );
                    clearInterval(interTime);
                  }}
                />
                &nbsp; {intl.get("3e75d03d-b11f-2023-afd9-11e72cb855d6")}
              </h2>
              <Form
                form={regFormTeam}
                name="basic"
                onFinish={onFinish}
                autoComplete="off"
                className="login-main"
                initialValues={{ supplierType: 3, isOverseas: 1 }}
                style={{ margin: "auto" }}
                labelWrap
                labelAlign="left"
              >
                <Form.Item>
                  <Alert
                    message={intl.get(
                      "Approval_e20410ac-337c-23ac-bdfd-ce4dd98f3f1f_Approval",
                    )}
                    banner
                  />
                </Form.Item>

                <Form.Item
                  name="supplierType"
                  label={intl.get(
                    "Supplier_Type_fdfa220a-830f-274c-ab6e-d47d9dfa4f5f",
                  )}
                  className="special labelWidth"
                  rules={[{ required: true }]}
                >
                  <Radio.Group onChange={supplierChange}>
                    <Radio value={3}>
                      {intl.get(
                        "Enterprise_Supplier_915e1fc2-552b-239e-be1d-3515a3e8ff8a",
                      )}
                    </Radio>
                    <Radio value={1}>
                      {intl.get(
                        "Individual_Supplier_7250652a-f2df-294d-a15d-bac240bd8419",
                      )}
                    </Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item
                  label={intl.get(
                    "Non-Chinese_Supplier_16f528b3-db1a-2a65-bb4e-2d3f2a57823e",
                  )}
                  className="special labelWidth"
                  name="isOverseas"
                  rules={[{ required: true }]}
                >
                  <Radio.Group onChange={seaSupplierChange}>
                    <Radio value={1}>
                      {intl.get("No_055a24d6-5d33-2f3c-951d-033ea30c62d8")}
                    </Radio>
                    <Radio value={2}>
                      {intl.get("Yes_87fddcb6-1cfa-2295-ae0f-b04062a4c122")}
                    </Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item
                  name="supplierName"
                  label={intl.get(
                    "Supplier_Principal_Name_1dcb2f00-8880-20ad-af0e-b55700e09f3f",
                  )}
                  className="special"
                  rules={[
                    {
                      required: true,
                      message: intl.get("f3b463e6-398f-24ef-b440-30a129c295a1"),
                    },
                    {
                      pattern: new RegExp(/^(?!\s)(?!.*\s$)/),
                      message: intl.get(
                        "Correct_274ca174-9cf3-270a-9a4f-91b9e00cf937_Correct",
                      ),
                    },
                  ]}
                >
                  <Input
                    maxLength={50}
                    size="large"
                    placeholder={
                      supplierType === 3
                        ? intl.get(
                            "Name_513a9b27-a988-231e-8854-f308c98379f1_Name",
                          )
                        : intl.get(
                            "Name_e72ab80b-c16b-25e0-9042-4916da225757_Name",
                          )
                    }
                  />
                </Form.Item>

                <ErCode
                  type={isOverseas}
                  isCheck={true}
                  nextStep={nextStep}
                  isReg={true}
                  forms={regFormTeam}
                />

                <Form.Item
                  label={intl.get(
                    "Password_53aeeeeb-f4b2-2ec7-8378-0824b54674f2",
                  )}
                  name="password"
                  className="special"
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: intl.get(
                        "Password_e20ad08a-94e5-2741-8abc-622d44e1ef0d_Password",
                      ),
                    },
                    {
                      pattern: new RegExp(
                        /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
                      ),
                      message: intl.get(
                        "Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb",
                      ),
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder={intl.get(
                      "Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb",
                    )}
                  />
                </Form.Item>

                <Form.Item
                  label={intl.get(
                    "Confirm_password_c11a821c-0a36-263d-a77a-30097899f35e",
                  )}
                  name="passwordConfirm"
                  className="special"
                  dependencies={["password"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: intl.get(
                        "Password_e20ad08a-94e5-2741-8abc-622d44e1ef0d_Password",
                      ),
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            intl.get(
                              "The_passwords_entered_twice_do_not_match_8613bcda-26a3-2814-95fc-027239abaee3",
                            ),
                          ),
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder={intl.get(
                      "Password_Rule_4875f563-f36e-2cf1-8b76-ec7eb40f05bb",
                    )}
                  />
                </Form.Item>

                <Form.Item className="login-btn">
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    style={{ width: "100%" }}
                  >
                    {intl.get(
                      "Create_one_8d829590-c95d-2efd-b0b0-89efd94ce07d",
                    )}
                  </Button>
                </Form.Item>

                <Form.Item className="login-read">
                  <Checkbox
                    checked={agreeFlag}
                    onChange={(e) => {
                      setAgreeFlag(e.target.checked);
                    }}
                  >
                    {intl.get(
                      "Read_agreeed_1f509815-fe90-291d-a8b5-a4ce092c8739",
                    )}
                    <span className="login-read-serve" onClick={openAgreeMent}>
                      {intl.get(
                        "Team_agreement_877db9c4-062c-2fe7-8f57-3be9dd4a4092",
                      )}
                    </span>
                  </Checkbox>
                </Form.Item>
                <Divider />

                <Form.Item className="login-reg">
                  <span>
                    {intl.get(
                      "Already_account_64840ff2-f4a2-26ad-ac9b-ae0bff3bc483",
                    )}
                    <span
                      className="login-reg-register"
                      onClick={() => {
                        setIsLogin(1);
                        setCurrentKey(1);
                        setAgreeFlag(false);
                      }}
                    >
                      {intl.get("Login_7b3caf4e-b296-2437-9bb8-b25c327406d8")}
                    </span>
                  </span>
                </Form.Item>
              </Form>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}

      <div className="copyright">
        Copyright ©2021   北京海天瑞声科技股份有限公司
        <a
          className="ba"
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/index"
        >
          京ICP备12041558号-6
        </a>
        <a
          className="ba"
          target="_blank"
          href="https://beian.miit.gov.cn/#/Integrated/index"
        >
          经营许可证编号：合字B2-20230395
        </a>
        <a
          className="ba"
          target="_blank"
          href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802043350"
        >
          <img src={pol} alt="" style={{ width: "15px", marginTop: "-2px" }} />
          京公网安备11010802043350
        </a>
      </div>

      <CustomerFeedback />

      {/* 注册信息核实 */}
      <Modal
        title={intl.get(
          "Registration_5486a392-9617-2948-a31a-a869e5c876a5_Registration",
        )}
        visible={regMess}
        onCancel={() => {
          setRegMess(false);
        }}
        className="register-message"
        centered
        maskClosable={false}
        footer={null}
      >
        <Form>
          <Form.Item>
            <Alert
              message={intl.get(
                "Supplier_1f1b74ee-4393-2ec8-b7d9-1c3f7d425d35_Supplier",
              )}
              banner
            />
          </Form.Item>
          <Form.Item>
            <span>
              {intl.get("Supplier_Type_fdfa220a-830f-274c-ab6e-d47d9dfa4f5f")}
            </span>
            ：
            <span>
              {supplierType === 1
                ? intl.get(
                    "Individual_Supplier_7250652a-f2df-294d-a15d-bac240bd8419",
                  )
                : intl.get(
                    "Enterprise_Supplier_915e1fc2-552b-239e-be1d-3515a3e8ff8a",
                  )}
            </span>
          </Form.Item>
          <Form.Item>
            <span>
              {intl.get(
                "Non-Chinese_Supplier_16f528b3-db1a-2a65-bb4e-2d3f2a57823e",
              )}
            </span>
            ：
            <span>
              {isOverseas === 1
                ? intl.get("No_055a24d6-5d33-2f3c-951d-033ea30c62d8")
                : intl.get("Yes_87fddcb6-1cfa-2295-ae0f-b04062a4c122")}
            </span>
          </Form.Item>
          <Form.Item>
            <span>
              {intl.get(
                "Supplier_Principal_Name_1dcb2f00-8880-20ad-af0e-b55700e09f3f",
              )}
              ：
            </span>
            <span>{supplierName}</span>
          </Form.Item>
          <Form.Item className="forget-password-buttonGroup">
            <Button
              type="primary"
              onClick={regMessSure}
              size="large"
              className="themeBgColor"
            >
              {intl.get("Confirm_fc189f71-934f-2caa-bd8f-29b9460afa19")}
            </Button>
            <Button
              size="large"
              onClick={() => {
                setRegMess(false);
              }}
            >
              {intl.get("Modify_4d9eb5b2-4aa0-2cde-85f6-315795666b15")}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      {/* 服务协议 */}
      <Modal
        title={
          currentKey == 1
            ? intl.get(
                "Speechocean_add23cdc-28f1-2c03-be4f-63a75619ddf6_Speechocean",
              )
            : intl.get("Team_add23cdc-28f1-2c03-be4f-63a75619ddf6_Speechocean")
        }
        centered
        visible={agreeMent}
        className="aggreeMentModal"
        onCancel={closeAgreeMent}
        maskClosable={false}
        footer={[]}
        width={1200}
      >
        <div className="box">
          <Content>
            <FileViewer
              key={currentKey}
              fileType="docx" //文件类型
              filePath={currentKey == 1 ? filePath : teamFilePath} //文件地址
            />
          </Content>
        </div>
        <Button
          disabled={agreeTime === "" ? false : true}
          size="large"
          type="primary"
          style={{ color: "#fff", marginTop: "30px" }}
          onClick={closeAgreeMentSure}
        >
          {intl.get("Read_agreeed_1f509815-fe90-291d-a8b5-a4ce092c8739")}
          {agreeTime}
        </Button>
      </Modal>

      {/* 认证弹窗 */}
      <Modal
        className="renzhengModal"
        title=""
        centered
        visible={subModalFlag}
        footer={false}
        closable={false}
        maskClosable={false}
      >
        <div
          style={{
            color: "#1D2129",
            fontSize: "16px",
            fontWeight: 500,
            marginBottom: "39px",
          }}
        >
          <img
            style={{ marginTop: "-5px", marginRight: "5px" }}
            width="30"
            src={RZ}
          />
          {intl.get("8fe87ea4-acca-2e1a-809a-7467657ddada")}
        </div>
        <div style={{ textAlign: "left" }}>
          {intl.get("abdcf80f-944f-2f7b-9327-2feb6fa0e877")}
        </div>
        <div>
          <Button
            size="large"
            type="primary"
            onClick={() => {
              setSubModalFlag(false);
              setSubModalFlag1(true);
              regFormTeam.resetFields();
              regFormTerminal.resetFields();
              authForm.resetFields();
            }}
          >
            {intl.get("3db0e663-0a72-2605-bb43-2d8a5ef91671")}
          </Button>
          <Button
            size="large"
            onClick={() => {
              setSubModalFlag(false);
            }}
          >
            {intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d")}
          </Button>
        </div>
      </Modal>

      {/* 账号认证1 */}
      <Modal
        className="renzhengModal1"
        title=""
        centered
        visible={subModalFlag1}
        onCancel={() => {
          setSubModalFlag1(false);
        }}
        footer={false}
        maskClosable={false}
      >
        <div className="second">
          {intl.get("138873dd-a6aa-22ed-ab61-c5f129181a4d")}
        </div>
        <div className="three">
          {intl.get("db8b5b41-3011-283e-a818-2651753f80df")}
        </div>
        <div className="first">
          <Row>
            <Col span={6}>
              <span className="firstLabel">
                {intl.get(
                  "Mobile_phone_number_1369de70-73d4-254a-a628-3eaf126e7217",
                )}
                :
              </span>
            </Col>
            <Col span={18}>
              <Input
                value={getUserInfoToLocalEmailPhone().mobile}
                size="large"
                disabled
              ></Input>
              <span
                style={
                  getUserInfoToLocal().userType == 2 &&
                  getUserInfoToLocal().isOverseas == 2
                    ? { display: "none" }
                    : getUserInfoToLocalEmailPhone().verify == 2
                      ? yrz
                      : wrz
                }
                className="first-box"
              >
                {getUserInfoToLocalEmailPhone().verify == 2
                  ? intl.get("2d070c07-eaf9-2434-aa2c-1257c2d590a0")
                  : intl.get("35224c5b-0c8f-221d-b1fe-d04fefa0a7fa")}
              </span>
            </Col>
          </Row>
        </div>
        <div className="first">
          <Row>
            <Col span={6}>
              <span className="firstLabel">
                {intl.get("Email_c1358cc1-828e-291f-a81e-46733c5fe410")}:
              </span>
            </Col>
            <Col span={18}>
              {" "}
              <Input
                value={getUserInfoToLocalEmailPhone().email}
                size="large"
                disabled
              ></Input>
              <span
                style={getUserInfoToLocalEmailPhone().verify == 3 ? yrz : wrz}
                className="first-box"
              >
                {getUserInfoToLocalEmailPhone().verify == 3
                  ? intl.get("2d070c07-eaf9-2434-aa2c-1257c2d590a0")
                  : intl.get("35224c5b-0c8f-221d-b1fe-d04fefa0a7fa")}
              </span>
            </Col>
          </Row>
        </div>
        <div className="firstButton">
          {getUserInfoToLocal().userType == 2 &&
          getUserInfoToLocal().isOverseas == 2 ? (
            ""
          ) : (
            <Button
              type="primary"
              size="large"
              className="themeBgColor"
              onClick={() => {
                if (getUserInfoToLocalEmailPhone().verify != 2) {
                  setSubModalFlag1(false);
                  setSubModalFlag2(true);
                  setMethodsStatus(1);
                }
              }}
            >
              {intl.get("9f298649-5419-25e4-8e83-09b8d6cfb616")}
            </Button>
          )}
          <Button
            type="primary"
            size="large"
            className="themeBgColor"
            onClick={() => {
              if (getUserInfoToLocalEmailPhone().verify != 3) {
                setSubModalFlag1(false);
                setSubModalFlag2(true);
                setMethodsStatus(2);
              }
            }}
          >
            {intl.get("bdf76e72-619e-2b65-a005-5a469965addc")}
          </Button>
        </div>
      </Modal>

      {/* 账号认证2 */}
      <Modal
        className="renzhengModal2"
        title={intl.get("138873dd-a6aa-22ed-ab61-c5f129181a4d")}
        centered
        visible={subModalFlag2}
        onCancel={() => {
          setSubModalFlag2(false);
        }}
        footer={false}
        maskClosable={false}
      >
        <Form
          form={authForm}
          name="auth"
          onFinish={onAuthForm}
          autoComplete="off"
          className="login-main"
          labelWrap
          labelAlign="left"
        >
          <ErCode
            type={methodsStatus}
            isCheck={true}
            nextStep={nextStep}
            isReg={true}
            forms={authForm}
            renzheng={true}
          />

          <Form.Item className="login-btn">
            <div className="firstButton">
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                className="themeBgColor"
              >
                {intl.get("Confirm_fc189f71-934f-2caa-bd8f-29b9460afa19")}
              </Button>
              <Button
                onClick={() => {
                  setSubModalFlag2(false);
                }}
                size="large"
              >
                {intl.get("Cancel_51f2be22-0a99-2045-95f1-81feae4ea69d")}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
      {isTeamBindModal && (
        <TeamBindModal
          isTeamBindModal={isTeamBindModal}
          type={bindModalType}
          chooseTeam={(dataList) => {
            setTeamBindDataList(dataList);
            setIsTeamStartModal(true);
          }}
          loginData={loginData}
          confirm={(values, type) => {
            setCurrentKey(2);
            if (type === "register") {
              loginFun(values);
            }
            if (type === "active") {
              loginSuccess(values);
            }
            setIsTeamBindModal(false);
          }}
          dataSource={teamData}
          closeModal={() => {
            setIsTeamBindModal(false);
          }}
        />
      )}
      {isTeamStartModal && (
        <TeamBindModal
          isTeamBindModal={isTeamStartModal}
          type={"choose"}
          dataSource={teamBindDataList}
          chooseTeam={null}
          loginData={loginData}
          confirm={(values, type) => {
            if (type === "active") {
              setCurrentKey(2);
              loginSuccess(values);
            }
            setIsTeamStartModal(false);
            setIsTeamBindModal(false);
          }}
          closeModal={() => {
            setIsTeamStartModal(false);
          }}
        />
      )}
    </div>
  );
}
